import { I as InputOtp, d as defineCustomElement$1 } from './p-b33NVvKu.js';

const WangsInputOtp = InputOtp;
const defineCustomElement = defineCustomElement$1;

export { WangsInputOtp, defineCustomElement };
